(function () {
  const pushEvent = (eventName, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...payload,
    });
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-track-request-button]");
    if (!button) return;

    pushEvent("b2b_request_button_click", {
      request_action: button.dataset.trackRequestAction || "",
      request_context: button.dataset.trackRequestContext || "",
      product_id: button.dataset.productId || "",
      product_title: button.dataset.productTitle || "",
      product_vendor: button.dataset.productVendor || "",
      destination_url: button.getAttribute("href") || "",
    });
  });
})();
